module.exports = __webpack_public_path__ + "img/data-dive.28fd9397.jpg";